let codigos = [];

// Se llama una sola vez, al arrancar la app (ver index.js)
export function cargarEventosEspeciales() {
    return fetch(`${process.env.PUBLIC_URL}/config/eventos-especiales.txt`, { cache: 'no-store' })
        .then((res) => res.ok ? res.text() : "")
        .then((texto) => {
            codigos = texto
                .split(/\r?\n/)
                .map((linea) => linea.trim())
                .filter((linea) => linea !== "" && !linea.startsWith("#"));
        })
        .catch(() => {
            // Si el archivo no existe o falla la lectura, la app sigue
            // funcionando como si la lista estuviera vacia.
            codigos = [];
        });
}

export function esEventoEspecial(id) {
    if (id === null || id === undefined) {
        return false;
    }
    return codigos.includes(String(id).trim());
}